/*
 * Reglas del bloque `embed` compartidas por el registro de tipos y el componente,
 * espejo de `App\Services\LMS\Blocks\Types\EmbedBlock` (LMS-073). La lista de
 * dominios permitidos vive solo en el backend.
 */
export const EMBED_MIN_HEIGHT = 100
export const EMBED_MAX_HEIGHT = 3000
export const EMBED_DEFAULT_HEIGHT = 480

export const isHttpsUrl = (value) => {
    try {
        return new URL(value).protocol === 'https:'
    } catch {
        return false
    }
}

export const urlHost = (value) => {
    try {
        return new URL(value).hostname
    } catch {
        return ''
    }
}

export const isValidEmbedHeight = (height) => height === null || height === undefined || height === ''
    || (Number.isInteger(height) && height >= EMBED_MIN_HEIGHT && height <= EMBED_MAX_HEIGHT)
